import type { TFunction } from 'i18next';

export const planColors = {
  Free: 'var(--color-lime-500)',
  Basic: 'var(--color-blue)',
  Growth: 'var(--color-red-400)',
  'Basic | Growth': 'var(--color-orange-500)',
};

export const upgradeBenefits = (t: TFunction) => {
  return [
    {
      key: 'projects',
      title: t('UpgradeBenefits.MoreProjectsAndEnvironments.Title'),
      description: t('UpgradeBenefits.MoreProjectsAndEnvironments.Description'),
    },
    {
      key: 'integrations',
      title: t('UpgradeBenefits.AdvancedIntegrations.Title'),
      plan: 'Basic',
      color: planColors['Basic'],
      description: t('UpgradeBenefits.AdvancedIntegrations.Description'),
    },
    {
      key: 'team',
      title: t('UpgradeBenefits.TeamCollaboration.Title'),
      plan: 'Basic | Growth',
      color: planColors['Basic | Growth'],
      description: t('UpgradeBenefits.TeamCollaboration.Description'),
    },
    {
      key: 'support',
      title: t('UpgradeBenefits.PrioritySupport.Title'),
      plan: 'Growth',
      color: planColors['Growth'],
      description: t('UpgradeBenefits.PrioritySupport.Description'),
    },
  ];
};
